var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ComposedPlaceholderStatus',{attrs:{"icon":{
        name: 'big-notifications',
        path: 'two-tone',
        size: 'big-s',
    },"title":_vm.$t('notifications_empty_title'),"description":_vm.$t('notifications_empty_description')}})
}
var staticRenderFns = []

export { render, staticRenderFns }